import { Parcel } from "./Parcel";
import { PreparationOrder } from "./PreparationOrder";
import { ShippingFile } from "./ShippingFile";
import { ShippingRecord } from "./ShippingRecord";

export enum ShippingAddressEntityType {
  DOCKYARD = "DOCKYARD",
  WAREHOUSE = "WAREHOUSE",
  OTHER = "OTHER",
}

export type ShippingAddress = {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  company: string | null;
  street1: string;
  street2: string | null;
  city: string;
  state: string | null;
  zip: string;
  country: string;
  phone: string;
  email: string | null;
  entityType: ShippingAddressEntityType;
  entityId: string | null;
};

export enum ShipmentStatus {
  DRAFT = "DRAFT",
  TO_SHIP = "TO_SHIP",
  SHIPPED = "SHIPPED",
  CANCELED = "CANCELED",
  DELIVERED = "DELIVERED",

  // IN_TRANSIT = "IN_TRANSIT",
  // OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  // MISSED_DELIVERY = "MISSED_DELIVERY",
  // EXCEPTION = "EXCEPTION",
}

export type Shipment = {
  id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  shippingRecordId?: string;
  shippingRecord?: ShippingRecord;
  opId: string;
  op?: PreparationOrder;
  refPreparation?: string;
  fromAddressId?: string;
  fromAddress: Partial<ShippingAddress>;
  toAddressId?: string;
  toAddress: Partial<ShippingAddress>;
  status?: ShipmentStatus;
  connectorOrderId?: string;
  trackingNumber?: string;
  trackingUrl?: string;
  trackingCarrierName?: string;
  files?: ShippingFile[];
  labels?: ShippingFile[];
  manifests?: ShippingFile[];
  proofOfDelivery?: ShippingFile;
  parcelId?: string;
  parcel?: Parcel;
};
